import dispatcher from "./../Dispatcher/Dispatcher";
import { EventEmitter } from "events";
import equipmentGroupConstants from "./../Constants/EquipmentGroupConstants";

let equipmentGroupList = [];
let navbarItem = [];
let equipments = [];
let tabMenu = [];
let result = [];
let exportData = [];
let exportoverDue = [];
let exportNIODue = [];
let exportOrderOverView = [];
let orgEquipmentList = [];
let addorUpdateEquipmentGroupResult = null;
let plantEquipmentGroupList = [];
let deleteEquipmentGroupResult = null;
let equipment = [];
let addorUpdateEquipmentResult = null;
let herstellers = [];
let deleteHersteller = [];
let deleteBezeichnung = [];
let addOrUpdateHerstellers = [];
let addEquipmentToEquGrpResult = [];
let equipmentListByEquGroup = [];
let deleteEquipmentForEquGrpResult = null;
let herstellerListByEquGroup = [];
let addHerstellerToEquGrp = [];
let deleteherstellerToequGrp = [];
let functionList = [];
let addorUpdateFunctionRes = null;
let menuList = [];
let addOrUpdateMenuToEquGrp = [];
let standardAttributes = [];
let addOrUpdateStandardAttributesToEquGup = [];
let removeStandardAttributesToEquGup = [];
let testGroupList = [];
let addTestGroupRes = null;
let testGroupListByEquGrpId = null;
let deleteTestGroupForEquGrpRes = null;
let fixedDateSetResult = null;
let copyEquipmentGroupResult = null;
let equipmentGridList = null;
let gridOverDueRes = null;
let gridNioRes = null;
let gridOrderOverRes = null;
let gridInactiveRes = null;
let getOptionEqGrp = null;
let getSingleEqGrp = null;
let geteqGrpSummary = null;
let equipmentGroupListByPlant = null;
let saveInspectionReportAttrRes = null;
let getInspectionReportAttrRes = null;
let getBulkExportInspectionReportRes = null;
let getManageTicketEquipmentGrp = null;
class EquipmentGroupStore extends EventEmitter {
  getNavbarItem() {
    return navbarItem;
  }
  updateNavbarItem(result) {
    navbarItem = result;
  }
  getTabs() {
    return tabMenu;
  }
  setTabs(res) {
    tabMenu = res;
  }

  getEquipmentGroupList() {
    return equipmentGroupList;
  }
  getEquipments() {
    return equipments;
  }

  getResult() {
    return result;
  }
  setResult(res) {
    result = res;
  }

  getExport() {
    return exportData;
  }
  setExport(res) {
    exportData = res;
  }
  getOverDueExport() {
    return exportoverDue;
  }
  setOverDueExport(res) {
    exportoverDue = res;
  }
  getNIoExport() {
    return exportNIODue;
  }
  setNIOExport(res) {
    exportNIODue = res;
  }
  getOderOverViewExport() {
    return exportOrderOverView;
  }
  setOderOverViewExport(res) {
    exportOrderOverView = res;
  }

  updateEquipmentGroupList(result) {
    equipmentGroupList = result;
  }
  setEquipments(result) {
    equipments = result;
  }
  getOrgEquipmentGroupResult() {
    return orgEquipmentList;
  }
  setOrgEquipmentGroupResult(result) {
    orgEquipmentList = result;
  }

  getAddorUpdateEquipmentGroupResult() {
    return addorUpdateEquipmentGroupResult;
  }

  setAddorUpdateEquipmentGroupResult(res) {
    addorUpdateEquipmentGroupResult = res;
  }

  getPlantEquipmentGroupList() {
    return plantEquipmentGroupList;
  }

  setPlantEquipmentGroupList(res) {
    plantEquipmentGroupList = res;
  }

  getDeleteEquipmentGroupResult() {
    return deleteEquipmentGroupResult;
  }

  setDeleteEquipmentGroupResult(res) {
    deleteEquipmentGroupResult = res;
  }

  getEquipment() {
    return equipment;
  }

  setEquipment(res) {
    equipment = res;
  }

  getAddorUpdateEquipmentResult() {
    return addorUpdateEquipmentResult;
  }

  setAddorUpdateEquipmentResult(res) {
    addorUpdateEquipmentResult = res;
  }

  getHerstellers() {
    return herstellers;
  }

  setHerstellers(res) {
    herstellers = res;
  }

  getAddOrUpdateHerstellers() {
    return addOrUpdateHerstellers;
  }
  setAddOrUpdateHerstellers(res) {
    addOrUpdateHerstellers = res;
  }

  getDeleteHersteller() {
    return deleteHersteller;
  }

  setDeleteHersteller(res) {
    deleteHersteller = res;
  }

  getDeleteBezeichnung() {
    return deleteBezeichnung;
  }

  setDeleteBezeichnung(res) {
    deleteBezeichnung = res;
  }

  getAddEquipmentToEquGrpResult() {
    return addEquipmentToEquGrpResult;
  }

  setAddEquipmentToEquGrpResult(res) {
    addEquipmentToEquGrpResult = res;
  }

  getEquipmentByEquGrpResult() {
    return equipmentListByEquGroup;
  }

  setEquipmentByEquGrpResult(res) {
    equipmentListByEquGroup = res;
  }

  getDeleteEquipmentForEquGrpResult() {
    return deleteEquipmentForEquGrpResult;
  }

  setDeleteEquipmentForEquGrpResult(res) {
    deleteEquipmentForEquGrpResult = res;
  }

  getHerstellerByEquGroup() {
    return herstellerListByEquGroup;
  }

  setHerstellerByEquGroup(res) {
    herstellerListByEquGroup = res;
  }

  getAddHerstellerToEquGrp() {
    return addHerstellerToEquGrp;
  }

  setAddHerstellerToEquGrp(res) {
    addHerstellerToEquGrp = res;
  }

  getDeleteherstellerToequGrp() {
    return deleteherstellerToequGrp;
  }

  setDeleteherstellerToequGrp(res) {
    deleteherstellerToequGrp = res;
  }

  getFunction() {
    return functionList;
  }

  setFunction(res) {
    functionList = res;
  }

  getAddOrUpdateFunctionToEquGrp() {
    return addorUpdateFunctionRes;
  }

  setAddOrUpdateFunctionToEquGrp(res) {
    addorUpdateFunctionRes = res;
  }

  getMenu() {
    return menuList;
  }

  setMenu(res) {
    menuList = res;
  }

  getAddOrUpdateMenuToEquGrp() {
    return addOrUpdateMenuToEquGrp;
  }

  setAddOrUpdateMenuToEquGrp(res) {
    addOrUpdateMenuToEquGrp = res;
  }

  getStandardAttributes() {
    return standardAttributes;
  }

  setStandardAttributes(res) {
    standardAttributes = res;
  }

  getAddOrUpdateStandardAttributes() {
    return addOrUpdateStandardAttributesToEquGup;
  }

  setAddOrUpdateStandardAttributes(res) {
    addOrUpdateStandardAttributesToEquGup = res;
  }

  getRemoveStandardAttributesToEquGup() {
    return removeStandardAttributesToEquGup;
  }

  setRemoveStandardAttributesToEquGup(res) {
    removeStandardAttributesToEquGup = res;
  }

  getTestGroupResult() {
    return testGroupList;
  }

  setTestGroupResult(res) {
    testGroupList = res;
  }

  getAddTestGroupResult() {
    return addTestGroupRes;
  }

  setAddTestGroupResult(res) {
    addTestGroupRes = res;
  }

  getTestGroupByEquGrpIdResult() {
    return testGroupListByEquGrpId;
  }

  setTestGroupByEquGrpIdResult(res) {
    testGroupListByEquGrpId = res;
  }

  getDeleteTestGroupForEquGrpResult() {
    return deleteTestGroupForEquGrpRes;
  }

  setDeleteTestGroupForEquGrpResult(res) {
    deleteTestGroupForEquGrpRes = res;
  }
  getFixedDateSetResult() {
    return fixedDateSetResult;
  }

  setFixedDateSetResult(res) {
    fixedDateSetResult = res;
  }

  geCopyEquipmentGroupResult() {
    return copyEquipmentGroupResult;
  }

  setCopyEquipmentGroupResult(res) {
    copyEquipmentGroupResult = res;
  }

  getEquipmentListGrid(result) {
    return equipmentGridList;
  }
  setEquipmentListGrid(result) {
    equipmentGridList = result;
  }

  getEquipmentOverDueListGrid(result) {
    return gridOverDueRes;
  }
  setEquipmentOverDueListGrid(result) {
    gridOverDueRes = result;
  }

  getEquipmentNIOListGrid(result) {
    return gridNioRes;
  }
  setEquipmentNIOListGrid(result) {
    gridNioRes = result;
  }

  getEquipmentOrderOverviewListGrid(result) {
    return gridOrderOverRes;
  }
  setEquipmentOrderOverviewListGrid(result) {
    gridOrderOverRes = result;
  }

  getEquipmentInactiveListGrid(result) {
    return gridInactiveRes;
  }
  setEquipmentInactiveListGrid(result) {
    gridInactiveRes = result;
  }

  getOptionEqGrpResult(result) {
    return getOptionEqGrp;
  }
  setOptionEqGrpResult(result) {
    getOptionEqGrp = result;
  }

  getPaticularEqGrpResult(result) {
    return getSingleEqGrp;
  }
  setPaticularEqGrpResult(result) {
    getSingleEqGrp = result;
  }
  getSummaryEqGrpResult(result) {
    return geteqGrpSummary;
  }
  setSummaryEqGrpResult(result) {
    geteqGrpSummary = result;
  }
  getEquipmentGroupListByPlant() {
    return equipmentGroupListByPlant;
  }
  setEquipmentGroupListByPlant(_value) {
    equipmentGroupListByPlant = _value;
  }
  getSaveInspectionReportAttrRes() {
    return saveInspectionReportAttrRes;
  }
  setSaveInspectionReportAttrRes(_value) {
    saveInspectionReportAttrRes = _value;
  }
  getInspectionReportAttrRes() {
    return getInspectionReportAttrRes;
  }
  setInspectionReportAttrRes(_value) {
    getInspectionReportAttrRes = _value;
  }
  getBulkExportInspectionReportRes() {
    return getBulkExportInspectionReportRes;
  }
  setBulkExportInspectionReportRes(_value) {
    getBulkExportInspectionReportRes = _value;
  }
  getManageTicketEquipmentGrp() {
    return getManageTicketEquipmentGrp;
  }
  setManageTicketEquipmentGrp(_value) {
    getManageTicketEquipmentGrp = _value;
  }

  emitChange(eventName) {
    this.emit(eventName);
  }

  addChangeListener(eventName, callback) {
    this.on(eventName, callback);
  }

  removeChangeListener(eventName, callback) {
    this.removeListener(eventName, callback);
  }

  handleCallback(action) {
    switch (action.type) {
      case equipmentGroupConstants.GET_EQUIPMENTGROUP_SUCCESS:
        this.updateEquipmentGroupList(action.result);
        break;
      case equipmentGroupConstants.GET_EQUIPMENTGROUP_FAILURE:
        this.updateEquipmentGroupList(null);
        break;
      case equipmentGroupConstants.GET_NAVITEM_SUCCESS:
        this.updateNavbarItem(action.result);
        break;
      case equipmentGroupConstants.GET_NAVITEM_FAILURE:
        this.updateNavbarItem(null);
        break;
      case equipmentGroupConstants.GET_EQUIPMENTLIST_SUCCESS:
        this.setEquipments(action.result);
        break;
      case equipmentGroupConstants.GET_EQUIPMENTLIST_FAILURE:
        this.setEquipments(null);
        break;
      case equipmentGroupConstants.GET_TABSMENU_SUCCESS:
        this.setTabs(action.result);
        break;
      case equipmentGroupConstants.GET_TABSMENU_FAILURE:
        this.setTabs(null);
        break;
      case equipmentGroupConstants.GET_INACTIVEQUIPMENT_SUCCESS:
        this.setResult(action.result);
        break;
      case equipmentGroupConstants.GET_INACTIVEQUIPMENT_FAILURE:
        this.setResult(null);
        break;
      case equipmentGroupConstants.GET_AUFTRAEGELIST_SUCCESS:
        this.setResult(action.result);
        break;
      case equipmentGroupConstants.GET_AUFTRAEGELIST_FAILURE:
        this.setResult(null);
        break;
      case equipmentGroupConstants.GET_UEBERFAELLIGEPRUFUNG_SUCCESS:
        this.setResult(action.result);
        break;
      case equipmentGroupConstants.GET_UEBERFAELLIGEPRUFUNG_SUCCESS:
        this.setResult(null);
        break;
      case equipmentGroupConstants.GET_NIOANLAGE_SUCCESS:
        this.setResult(action.result);
        break;
      case equipmentGroupConstants.GET_NIOANLAGE_FAILURE:
        this.setResult(null);
        break;
      case equipmentGroupConstants.EXPORT_SUCCESS:
        this.setExport(action.result);
        break;
      case equipmentGroupConstants.GET_NIOANLAGE_FAILURE:
        this.setResult(null);
        break;
      case equipmentGroupConstants.EXPORT_OVERDUE_SUCCESS:
        this.setOverDueExport(action.result);
        break;
      case equipmentGroupConstants.EXPORT_OVERDUE_FAILURE:
        this.setOverDueExport(null);
        break;
      case equipmentGroupConstants.EXPORT_AUFTRAEGE_WITH_IMG_SUCCESS:
        this.setExport(action.result);
        break;
      case equipmentGroupConstants.EXPORT_AUFTRAEGE_WITH_IMG_FAILURE:
        this.setExport(null);
        break;
      case equipmentGroupConstants.EXPORT_UEBERFAELLIGEPRUFUNG_SUCCESS:
        this.setExport(action.result);
        break;
      case equipmentGroupConstants.EXPORT_UEBERFAELLIGEPRUFUNG_FAILURE:
        this.setExport(null);
        break;
      case equipmentGroupConstants.EXPORT_NIOANLAGE_SUCCESS:
        this.setExport(action.result);
        break;
      case equipmentGroupConstants.EXPORT_NIOANLAGE_FAILURE:
        this.setExport(null);
        break;
      case equipmentGroupConstants.GET_ORG_EQUIPMENT_SUCCESS:
        this.setOrgEquipmentGroupResult(action.result);
        break;
      case equipmentGroupConstants.GET_ORG_EQUIPMENT_FAILURE:
        this.setOrgEquipmentGroupResult(action.result);
        break;
      case equipmentGroupConstants.ADDORUPDATE_EQUIPMENT_GROUP_SUCCESS:
        this.setAddorUpdateEquipmentGroupResult(action.result);
        break;
      case equipmentGroupConstants.ADDORUPDATE_EQUIPMENT_GROUP_FAILURE:
        this.setAddorUpdateEquipmentGroupResult(action.result);
        break;
      case equipmentGroupConstants.GET_PLANT_EQUIPMENT_GROUP_SUCCESS:
        this.setPlantEquipmentGroupList(action.result);
        break;
      case equipmentGroupConstants.GET_PLANT_EQUIPMENT_GROUP_FAILURE:
        this.setPlantEquipmentGroupList(action.result);
        break;
      case equipmentGroupConstants.DELETE_EQUIPMENT_GROUP_SUCCESS:
        this.setDeleteEquipmentGroupResult(action.result);
        break;
      case equipmentGroupConstants.DELETE_EQUIPMENT_GROUP_FAILURE:
        this.setDeleteEquipmentGroupResult(action.result);
        break;
      case equipmentGroupConstants.GET_EQUIPMENT_SUCCESS:
        this.setEquipment(action.result);
        break;
      case equipmentGroupConstants.GET_EQUIPMENT_FAILURE:
        this.setEquipment(action.result);
        break;
      case equipmentGroupConstants.ADDORUPDATE_EQUIPMENT_SUCCESS:
        this.setAddorUpdateEquipmentResult(action.result);
        break;
      case equipmentGroupConstants.ADDORUPDATE_EQUIPMENT_FAILURE:
        this.setAddorUpdateEquipmentResult(action.result);
        break;
      case equipmentGroupConstants.GET_HERSTELLERS_SUCCESS:
        this.setHerstellers(action.result);
        break;
      case equipmentGroupConstants.GET_HERSTELLERS_FAILURE:
        this.setHerstellers(action.result);
        break;
      case equipmentGroupConstants.ADD_OR_UPDATE_HERSTELLERS_SUCCESS:
        this.setAddOrUpdateHerstellers(action.result);
        break;
      case equipmentGroupConstants.ADD_OR_UPDATE_HERSTELLERS_FAILURE:
        this.setAddOrUpdateHerstellers(action.result);
        break;
      case equipmentGroupConstants.DELETE_HERSTELLRS_SUCCESS:
        this.setDeleteHersteller(action.result);
        break;
      case equipmentGroupConstants.DELETE_HERSTELLRS_FAILURE:
        this.setDeleteHersteller(action.result);
        break;
      case equipmentGroupConstants.DELETE_DESIGNATION_SUCCESS:
        this.setDeleteBezeichnung(action.result);
        break;
      case equipmentGroupConstants.DELETE_DESIGNATION_FAILURE:
        this.setDeleteBezeichnung(action.result);
        break;
      case equipmentGroupConstants.ADD_EQUIPMENT_TO_EQU_GROUP_SUCCESS:
        this.setAddEquipmentToEquGrpResult(action.result);
        break;
      case equipmentGroupConstants.ADD_EQUIPMENT_TO_EQU_GROUP_FAILURE:
        this.setAddEquipmentToEquGrpResult(action.result);
        break;
      case equipmentGroupConstants.GET_EQUIPMENT_BY_EQUGROUP_ID_SUCCESS:
        this.setEquipmentByEquGrpResult(action.result);
        break;
      case equipmentGroupConstants.GET_EQUIPMENT_BY_EQUGROUP_ID_FAILURE:
        this.setEquipmentByEquGrpResult(action.result);
        break;
      case equipmentGroupConstants.DELETE_EQUIPMENT_FOR_EQUGROUP_SUCCESS:
        this.setDeleteEquipmentForEquGrpResult(action.result);
        break;
      case equipmentGroupConstants.DELETE_EQUIPMENT_FOR_EQUGROUP_FAILURE:
        this.setDeleteEquipmentForEquGrpResult(action.result);
        break;
      case equipmentGroupConstants.GET_HERSTELLER_BY_EQUIPMENT_GROUP_ID_SUCCESS:
        this.setHerstellerByEquGroup(action.result);
        break;
      case equipmentGroupConstants.GET_HERSTELLER_BY_EQUIPMENT_GROUP_ID_FAILURE:
        this.setHerstellerByEquGroup(action.result);
        break;
      case equipmentGroupConstants.ADD_HERSTELLER_BY_EQUIPMENT_GROUP_ID_SUCCESS:
        this.setAddHerstellerToEquGrp(action.result);
        break;
      case equipmentGroupConstants.GET_HERSTELLER_BY_EQUIPMENT_GROUP_ID_FAILURE:
        this.setAddHerstellerToEquGrp(action.result);
        break;
      case equipmentGroupConstants.DELETE_HERSTELLER_BY_EQUIPMENT_GROUP_SUCCESS:
        this.setDeleteherstellerToequGrp(action.result);
        break;
      case equipmentGroupConstants.DELETE_HERSTELLER_BY_EQUIPMENT_GROUP_FAILURE:
        this.setDeleteherstellerToequGrp(action.result);
        break;
      case equipmentGroupConstants.GET_FUNCTION_SUCCESS:
        this.setFunction(action.result);
        break;
      case equipmentGroupConstants.GET_FUNCTION_FAILURE:
        this.setFunction(action.result);
        break;
      case equipmentGroupConstants.ADDORUPDATE_FUNCTION_TO_EQU_GRP_SUCCESS:
        this.setAddOrUpdateFunctionToEquGrp(action.result);
        break;
      case equipmentGroupConstants.ADDORUPDATE_FUNCTION_TO_EQU_GRP_FAILURE:
        this.setAddOrUpdateFunctionToEquGrp(action.result);
        break;
      case equipmentGroupConstants.GET_MENU_SUCCESS:
        this.setMenu(action.result);
        break;
      case equipmentGroupConstants.GET_MENU_FAILURE:
        this.setMenu(action.result);
        break;
      case equipmentGroupConstants.ADDORUPDATE_MENU_TO_EQU_GRP_SUCCESS:
        this.setAddOrUpdateMenuToEquGrp(action.result);
        break;
      case equipmentGroupConstants.ADDORUPDATE_MENU_TO_EQU_GRP_FAILURE:
        this.setAddOrUpdateMenuToEquGrp(action.result);
        break;
      case equipmentGroupConstants.GET_EQU_GUP_STANDARD_ATTRIBUTES_SUCCESS:
        this.setStandardAttributes(action.result);
        break;
      case equipmentGroupConstants.GET_EQU_GUP_STANDARD_ATTRIBUTES_FAILURE:
        this.setStandardAttributes(action.result);
        break;
      case equipmentGroupConstants.ADDORUPDATE_EQU_GUP_STANDARD_ATTRIBUTES_SUCCESS:
        this.setAddOrUpdateStandardAttributes(action.result);
        break;
      case equipmentGroupConstants.ADDORUPDATE_EQU_GUP_STANDARD_ATTRIBUTES_FAILURE:
        this.setAddOrUpdateStandardAttributes(action.result);
        break;
      case equipmentGroupConstants.REMOVE_STANDARD_ATTRIBUTES_EQU_GRP_SUCCESS:
        this.setRemoveStandardAttributesToEquGup(action.result);
        break;
      case equipmentGroupConstants.REMOVE_STANDARD_ATTRIBUTES_EQU_GRP_FAILURE:
        this.setRemoveStandardAttributesToEquGup(action.result);
        break;
      case equipmentGroupConstants.GET_TEST_GROUP_SUCCESS:
        this.setTestGroupResult(action.result);
        break;
      case equipmentGroupConstants.GET_TEST_GROUP_FAILURE:
        this.setTestGroupResult(action.result);
        break;
      case equipmentGroupConstants.ADD_TEST_GROUP_TO_EQU_GROUP_SUCCESS:
        this.setAddTestGroupResult(action.result);
        break;
      case equipmentGroupConstants.ADD_TEST_GROUP_TO_EQU_GROUP_FAILURE:
        this.setAddTestGroupResult(action.result);
        break;
      case equipmentGroupConstants.GET_TEST_GROUP_BY_EQUGROUP_ID_SUCCESS:
        this.setTestGroupByEquGrpIdResult(action.result);
        break;
      case equipmentGroupConstants.GET_TEST_GROUP_BY_EQUGROUP_ID_FAILURE:
        this.setTestGroupByEquGrpIdResult(action.result);
        break;
      case equipmentGroupConstants.DELETE_TEST_GROUP_FOR_EQUGROUP_SUCCESS:
        this.setDeleteTestGroupForEquGrpResult(action.result);
        break;
      case equipmentGroupConstants.DELETE_TEST_GROUP_FOR_EQUGROUP_FAILURE:
        this.setDeleteTestGroupForEquGrpResult(action.result);
        break;
      case equipmentGroupConstants.GET_FIXED_DATESET_SUCCESS:
        this.setFixedDateSetResult(action.result);
        break;
      case equipmentGroupConstants.GET_FIXED_DATESET_FAILURE:
        this.setFixedDateSetResult(action.result);
        break;
      case equipmentGroupConstants.COPY_EQUIPMENT_GROUP_SUCCESS:
        this.setCopyEquipmentGroupResult(action.result);
        break;
      case equipmentGroupConstants.COPY_EQUIPMENT_GROUP_FAILURE:
        this.setCopyEquipmentGroupResult(action.result);
        break;
      case equipmentGroupConstants.GET_GRID_EQUIPMENTLIST_SUCCESS:
        this.setEquipmentListGrid(action.result);
        break;
      case equipmentGroupConstants.GET_GRID_EQUIPMENTLIST_FAILURE:
        this.setEquipmentListGrid(action.result);
        break;
      case equipmentGroupConstants.GET_GRID_OVERDUE_EQUIPMENTLIST_SUCCESS:
        this.setEquipmentOverDueListGrid(action.result);
        break;
      case equipmentGroupConstants.GET_GRID_OVERDUE_EQUIPMENTLIST_FAILURE:
        this.setEquipmentOverDueListGrid(action.result);
        break;
      case equipmentGroupConstants.GET_GRID_NIO_EQUIPMENTLIST_SUCCESS:
        this.setEquipmentNIOListGrid(action.result);
        break;
      case equipmentGroupConstants.GET_GRID_NIO_EQUIPMENTLIST_FAILURE:
        this.setEquipmentNIOListGrid(action.result);
        break;
      case equipmentGroupConstants.GET_GRID_ORDEROVERVIEW_EQUIPMENTLIST_SUCCESS:
        this.setEquipmentOrderOverviewListGrid(action.result);
        break;
      case equipmentGroupConstants.GET_GRID_ORDEROVERVIEW_EQUIPMENTLIST_FAILURE:
        this.setEquipmentOrderOverviewListGrid(action.result);
        break;
      case equipmentGroupConstants.GET_GRID_INACTIVE_EQUIPMENTLIST_SUCCESS:
        this.setEquipmentInactiveListGrid(action.result);
        break;
      case equipmentGroupConstants.GET_GRID_INACTIVE_EQUIPMENTLIST_FAILURE:
        this.setEquipmentInactiveListGrid(action.result);
        break;
      case equipmentGroupConstants.EXPORT_NIO_SUCCESS:
        this.setNIOExport(action.result);
        break;
      case equipmentGroupConstants.EXPORT_NIO_FAILURE:
        this.setNIOExport(null);
        break;
      case equipmentGroupConstants.EXPORT_ORDEROVERVIEW_SUCCESS:
        this.setOderOverViewExport(action.result);
        break;
      case equipmentGroupConstants.EXPORT_ORDEROVERVIEW_FAILURE:
        this.setOderOverViewExport(null);
        break;
      case equipmentGroupConstants.GET_OPTION_EQUIP_GRP_SUCCESS:
        this.setOptionEqGrpResult(action.result);
        break;
      case equipmentGroupConstants.GET_OPTION_EQUIP_GRP_FAILURE:
        this.setOptionEqGrpResult(null);
        break;
      case equipmentGroupConstants.GET_PARTICULE_EQ_GRP_SUCCESS:
        this.setPaticularEqGrpResult(action.result);
        break;
      case equipmentGroupConstants.GET_OPTION_EQUIP_GRP_FAILURE:
        this.setPaticularEqGrpResult(null);
        break;
      case equipmentGroupConstants.GET_SUMMARY_EQ_GRP_SUCCESS:
        this.setSummaryEqGrpResult(action.result);
        break;
      case equipmentGroupConstants.GET_SUMMARY_EQ_GRP_FAILURE:
        this.setSummaryEqGrpResult(null);
        break;
      case equipmentGroupConstants.GET_EQUIPMENTGROUP_BY_PLANT_SUCCESS:
        this.setEquipmentGroupListByPlant(action.result);
        break;
      case equipmentGroupConstants.GET_EQUIPMENTGROUP_BY_PLANT_FAILURE:
        this.setEquipmentGroupListByPlant(null);
        break;
      case equipmentGroupConstants.SAVE_INSPECTION_REPORT_ATTR_SUCCESS:
        this.setSaveInspectionReportAttrRes(action.result);
        break;
      case equipmentGroupConstants.SAVE_INSPECTION_REPORT_ATTR_FAILURE:
        this.setSaveInspectionReportAttrRes(action.result);
        break;
      case equipmentGroupConstants.GET_INSPECTION_REPORT_CONF_SUCCESS:
        this.setInspectionReportAttrRes(action.result);
        break;
      case equipmentGroupConstants.GET_INSPECTION_REPORT_CONF_FAILURE:
        this.setInspectionReportAttrRes(action.result);
        break;
      case equipmentGroupConstants.GET_BULK_INSPECTION_REPORT_SUCCESS:
        this.setBulkExportInspectionReportRes(action.result);
        break;
      case equipmentGroupConstants.GET_BULK_INSPECTION_REPORT_FAILURE:
        this.setBulkExportInspectionReportRes(action.result);
        break;
      case equipmentGroupConstants.GET_MANAGE_TICKET_EQUIPMENT_GRP_SUCCESS:
        this.setManageTicketEquipmentGrp(action.result);
        break;
      case equipmentGroupConstants.GET_MANAGE_TICKET_EQUIPMENT_GRP_FAILURE:
        this.setManageTicketEquipmentGrp(null);
        break;
      default:
        break;
    }
    this.emitChange(action.type);
    return true;
  }
}

const equipmentGroupStore = new EquipmentGroupStore();
dispatcher.register(
  equipmentGroupStore.handleCallback.bind(equipmentGroupStore),
);
export default equipmentGroupStore;
